import Settings from "../../../settings/Settings";

export default class Spinner extends Phaser.GameObjects.Container {
    private fade: Phaser.GameObjects.Image;
    // private image: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y);

        this.fade = this.scene.add.image(0, 0, 'atlas', 'blank');
        this.fade.setTint(0x000000);
        this.fade.setDisplaySize(scene.scale.width, scene.scale.height);
        this.fade.setInteractive();
        this.add(this.fade);

        this.createSpinnerWheel();

        const loadingLabel = this.scene.add.bitmapText(0, 40, Settings.FONTS.LXGW_CYRILLIC_BOLD, 'LOADING...', 50);
        loadingLabel.setOrigin(0.5, 0);
        loadingLabel.setTint(0xffffff);
        this.add(loadingLabel);
    }

    createSpinnerWheel() {
        // Main spinner outline
        const outerCircle = this.scene.add.graphics();
        outerCircle.lineStyle(3, 0xffffff, 1);
        outerCircle.strokeCircle(0, 0, 24); // 48px diameter

        const innerArc = this.scene.add.graphics();
        innerArc.lineStyle(3, 0xff3d00, 1);

        const arcRadius = 20; // Slightly smaller inner circle
        const arcAngle = Phaser.Math.DegToRad(270); // Draw 270° arc
        innerArc.beginPath();
        innerArc.arc(0, 0, arcRadius, 0, arcAngle);
        innerArc.strokePath();

        // Create a container to group and rotate
        const loaderContainer = this.scene.add.container(0, 0, [
            outerCircle,
            innerArc
        ]);
        this.add(loaderContainer)

        // Rotate it with a tween
        this.scene.tweens.add({
            targets: loaderContainer,
            angle: 360,
            duration: 1000,
            repeat: -1,
            ease: 'Linear'
        });
    }

    show() {
        this.setVisible(true);
    }

    hide() {
        this.setVisible(false);
    }
}
